import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import MagnifyingGlassChart from './icon-magnifying-glass-chart.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MagnifyingGlassChart {...validProps} />;
}
SvgComponent.iconName = 'magnifyingGlassChart';

export const MagnifyingGlassChartIcon = svgIconWrapper(SvgComponent);
